module.exports = function getResource(label, vars = []) {
    const resources = {
        quickTouchUp: 'Nous avons besoin d’une petite retouche.',
        maintenance: 'Le Babillard beauté a besoin d’un petit entretien, mais pas d’inquiétude : nous serons de retour en un rien de temps. En attendant, essayez l’espace de recherche pour trouver ce qu’il vous faut.',
        continueShopping: 'Continuer à magasiner'
    };

    return resources[label];
};
